<template>
  <div class="choose-org">
    <RemoteSelect
      v-model="orgId"
      placeholder="请选择机构"
      :remote-method="getOrgList"
      :loading="loadingOrg"
      :clearable="clearable"
      @clear="getOrgList('')"
      @visible-change="loadAllOrgList"
    >
      <el-option
        v-for="item in orgIdList"
        :key="item.orgId"
        :label="item.orgName"
        :value="item.orgId"
      >
      </el-option>
    </RemoteSelect>
  </div>
</template>

<script>
import RemoteSelect from '@c/RemoteSelect';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  name: 'ChooseOrg',
  components: {
    RemoteSelect
  },
  props: {
    yearTerms: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orgId: '',
      loadingOrg: false,
      orgIdList: []
    };
  },
  watch: {
    yearTerms: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          //    this.getOrgList()
        });
      },
      deep: true
    }
  },
  created() {
    // this.init()
  },
  methods: {
    init() {
      this.orgId = '';
      this.getOrgList();
    },
    getOrgId() {
      return this.orgId;
    },
    handleClear() {
      this.orgId = '';
    },
    loadAllOrgList(val) {
      if (!val) {
        this.getOrgList();
      }
    },
    // 获取提供方
    async getOrgList(orgName = '') {
      orgName ? this.loadingOrg = true : '';
      const searchParams = {};
      if (this.yearTerms.length && this.yearTerms[1]) {
        searchParams.yearCode = this.yearTerms[0];
        searchParams.termCode = this.yearTerms[1];
      } else {
        searchParams.yearCode = '';
        searchParams.termCode = '';
      }
      const res = await orderCenterApi.getWxOrgList({
        pageNum: 1,
        pageSize: 200,
        orgType: 4,
        // 因为包含学校提供方跟机构提供方，所以不传查所有
        orgName,
        ...searchParams
      });
      if (res.status === 200 && res.message.list) {
        const arr = [];
        this.orgIdList = [
          ...arr,
          ...res.message.list.map(item => {
            return { orgId: item.orgId, orgName: item.orgName || item.name };
          })
        ];
      }
      this.loadingOrg = false;
    }
  }
};
</script>

<style>
</style>
